<template>
<div class="popup-send-phone">
  <div class="u-popup-header">
    {{ $t('bookingPopup.popup.sendPhone.title') }}
  </div>
  <div class="u-popup-desc popup-send-phone__descr">
    {{ $t('bookingPopup.popup.sendPhone.desc') }}
  </div>

  <yt-input
    class="popup-send-phone__phone"
    type="phone"
    ref="phone"
    v-model="userContact.phone"
    :value="userContact.phone"
    @input="changePhone"
    :error="$v.userContact.phone.$error"
    :hint="$v.userContact.phone.$error ? !$v.userContact.phone.minLength ? $t('auth.initial.wrongPhone'):  $t('bookingPopup.popup.sandContact.error.phone') : ''"
  />
  <yt-button
    class="popup-send-phone__submit"
    color="green"
    @click="submitPopup"
  >
    {{ $t('bookingPopup.popup.sendPhone.btn') }}
  </yt-button>
  <div class="u-popup-note" >
    {{$t('bookingPopup.popup.termsGeneral.text1')}}
    <a href="/help/public-offer" target="_blank">{{$t('bookingPopup.popup.termsGeneral.textOffer')}}</a>
    {{$t('bookingPopup.popup.termsGeneral.text2')}}
    <a href="/help/privacy-agree" target="_blank">
      {{$t('bookingPopup.popup.termsGeneral.textPrivacy')}}
    </a>
  </div>
</div>


</template>

<script>

import YtInput from "@/components/ui-kit/yt-input";
import YtButton from "@/components/ui-kit/yt-button"
import {required} from "vuelidate/lib/validators";
export default {
  components: {
    YtInput,
    YtButton
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userData: {
      type: Object
    }
  },
  data() {
    return {
      userContact: {
        phone: "",
      }
    }
  },
  validations: {
    userContact: {
      phone: {
        required,
        minLength(value) {
          if (value.replaceAll(' ', '').replaceAll('+', '').length >= 10) {
            return true;
          }
          return false;
        },
      }
    }
  },
  methods: {
    changePhone(evt) {
      this.userContact.phone = evt;
    },
    submitPopup() {
      this.$v.$touch();

      if(this.$v.userContact.$error) {
        return;
      }
      this.$emit('send-contact-submit', {popup: 'send-phone', value: this.userContact});
    }
  },
  mounted() {
    this.userContact.phone = this.userData.phone;
    this.$emit('loaded');
  }
}
</script>

<style lang="scss" scoped>
.popup-send-phone {
  padding: 8px;
  &__descr {
      margin-bottom: 24px;
   }
  &__phone{
    width: 100%;
    margin-bottom: 20px;
  }
  &__phone.yt_input{
    width: 100%;
  }
  &__submit {
    width: 100%;
    margin-bottom: 16px;
  }
}
.u-popup-note a {
  color: inherit!important;
  text-decoration: underline;
  cursor: pointer;
}
</style>
